import React from "react";
import { useMessageSource } from "react-message-source";
import TextInputField from "../formik/text-input";

export default function CompanyDepartment({
  dataPath = "",
  value,
}: {
  dataPath?: string;
  value: string;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <TextInputField
      name={`${dataPath}companyDepartment`}
      label={getMessage("Person.companyDepartment")}
      value={value}
    />
  );
}
